import React, { Component } from 'react';
//import EmailModal from '../Buttons/EmailModal';
import GenericButton from '../Buttons/GenericButton';
import strings from '../strings';
import { saveLastResult } from './lastResult';
//import axios from 'axios';
import { lessonsList } from "../../data/lessonsList.js";
import LogModal from '../Buttons/LogModal';
import './LessonResults.css';
import { saveAs } from 'file-saver';


/*This component is for showing the results when the user either finishes the lesson or pauses it. */
/*
    Props Passed In:
        onResumeLesson - (function)
        onRestartLesson - (function)
        onNextLesson - (function)
        elapsedTime - (long in milliseconds)
        totalKeyInputs - (int)
        totalErrors - (int)
        isPaused - (boolean)
        LessonTitle - (string)
        lastDrill - (string)
        LessonId - (int)
*/
class LessonResults extends Component {
    constructor(props) {
        super(props);

        this.handleSave = this.handleSave.bind(this);
        this.resultsHeaderRef = React.createRef();
        this.totalWords = this.calculateTotalWords(this.props.totalKeyInputs, this.props.totalErrors);
        this.wordsPerMin = this.calculateWordsPerMin(this.props.totalKeyInputs, this.props.totalErrors, this.props.elapsedTime);
        this.lessonAccuracy = this.calculateAccuracy(this.props.totalKeyInputs, this.props.totalErrors);

        this.middleBtnText = !this.props.isPaused ? strings.REPEAT_BTN_TXT : strings.RESTART_BTN_TXT;
        this.middleBtnLabel = !this.props.isPaused ? strings.REPEAT_BTN_LABEL : strings.RESTART_BTN_LABEL;

        this.setLastResult(this.totalWords, this.wordsPerMin, this.props.totalErrors, this.lessonAccuracy);
    }


    componentDidMount() {
        if (this.resultsHeaderRef.current !== null)
            this.resultsHeaderRef.current.focus();//Have screen reader users start on the results header
    };


    calculateTotalWords = (totalKeyInputs, totalErrors) => {
        return Math.floor((totalKeyInputs - totalErrors) / 5);
    };


    calculateWordsPerMin = (totalKeyInputs, totalErrors, elapsedTime) => {
        let seconds = Math.floor(elapsedTime / 1000);
        let min = seconds / 60;
        return totalErrors !== 0 ? Math.floor((((totalKeyInputs) / 5) - (totalErrors / 5)) / min) : Math.floor(((totalKeyInputs) / 5) / min);
    };


    calculateAccuracy = (totalKeyInputs, totalErrors) => {
        return totalKeyInputs !== 0 ? Math.floor((((totalKeyInputs * 1.0) - totalErrors) / totalKeyInputs) * 100) : 0;
    };


    setLastResult = (totalWords, wordsPerMin, errors, lessonAccuracy) => {
        saveLastResult({ "lessonTitle": this.props.LessonTitle, "wordCount": totalWords + strings.TOTAL_WORDS, "wordsPerMin": wordsPerMin + strings.WPM, "errors": errors + strings.TOTAL_ERRORS, "accuracy": lessonAccuracy + strings.LESSON_ACCURACY });
    };


    //    showEmailModal = () => {
    //        let modal = document.getElementById("emailModal");
    //        if(modal){
    //            modal.style.display = "block";
    //        }

    //        let elem = document.getElementById("emailModalHeader");

    //        if(elem){
    //            elem.focus();
    //        }
    //    };


    /*    onSubmitEmail = async (event) => {
    //        if(true){
    //             alert("At this time this feature is not working. We are aware of the issue and are working to resolve this.")
    //        }
    //        else{//Once we get the email sending working we no longer need this if/else statement.
            event.preventDefault(event);
            let email = event.target.email.value;
            let studentID = event.target.studentID.value;
            let msg = `Student ID: ${studentID}\nLesson: ${this.props.LessonTitle}\nLesson Completed: ${!this.props.isPaused? "yes": "no"}\nLast Attempted Drill: ${this.props.lastDrill}\n${this.totalWords + strings.TOTAL_WORDS}\n${this.wordsPerMin + strings.WPM}\n${this.props.totalErrors + strings.TOTAL_ERRORS}\n${this.lessonAccuracy + strings.LESSON_ACCURACY}`;
            await this.sendNoReplyEmail(email, msg);
            this.onCancelEmail();//Close the email modal.
    //        }
        };
    
    
        onCopytoClipboard = async () => {
            //Temp function to allow users to copy the results of the test and submit them through their own means since the email feature is currently not working.
            //Make sure we have permission to write to clip board
            let msg = `Lesson: ${this.props.LessonTitle}\nLesson Completed: ${!this.props.isPaused? "yes": "no"}\nLast Attempted Drill: ${this.props.lastDrill}\n${this.totalWords + strings.TOTAL_WORDS}\n${this.wordsPerMin + strings.WPM}\n${this.props.totalErrors + strings.TOTAL_ERRORS}\n${this.lessonAccuracy + strings.LESSON_ACCURACY}`;
    
            navigator.clipboard.writeText(msg).then(
                () => {
                    //Clipboard successfully written to.
                    alert("Lesson results freaking copied to clip board.");
                },
                () => {
                    //Clipboard write failed
                    alert("Error occurred. Results could not be copied to clip board.");
                }
            );
        };
    
        sendTestEmail = () => {
            fetch("https://typer.aphtech.org/send", {
                method: "POST"
            })
            alert('email sent')
        };
    
    
        sendNoReplyEmail = async (email, msg) => {
            let request = {
                email: email,
                subject: strings.EMAIL_SUBJECT + this.props.LessonTitle,
                message: msg
            };
    
            axios({
                method: "POST",
                url: "https://typer.aphtech.org/send",
                data:request
            }).then((response) => {
                if(response.data.status === "success"){
                    alert("Message Sent");
                } else if(response.data.status === "fail"){
                    alert("Message failed to send");
                }
            });
        };
    
    
        onCancelEmail = () => {
            let modal = document.getElementById("emailModal");
            if(modal){
                modal.style.display = "none";
            }
        };*/

    showLogModal = () => {
        let modal = document.getElementById("logModal");
        if (modal) {
            modal.style.display = "block";
        }
        let elem = document.getElementById("logModalHeader");
        if (elem) {
            elem.focus();
        }
    };

    onCancelLog = () => {
        let modal = document.getElementById("logModal");
        if (modal) {
            modal.style.display = "none";
        }
    };

    onSubmitLog = async (event) => {
        let studentID = event.target.studentID.value;
        let date = new Date();
        let dateString = date.toLocaleString();
        let msg = `${dateString}\n${studentID ? `Student ID: ${studentID}\n` : ''}Lesson: ${this.props.LessonTitle}\nLesson Completed: ${!this.props.isPaused ? "yes" : "no"}\nLast Attempted Drill: ${this.props.lastDrill}\n${this.totalWords + strings.TOTAL_WORDS}\n${this.wordsPerMin + strings.WPM}\n${this.props.totalErrors + strings.TOTAL_ERRORS}\n${this.lessonAccuracy + strings.LESSON_ACCURACY}`;
        await this.handleSave(msg);
        this.onCancelLog();
    }

    handleSave = async (msg) => {
        const blob = new Blob([msg], { type: 'text/plain;charset=utf-8' });
        const date = new Date();
        const dateString = date.toISOString().split('T')[0];
        const filename = `results_${dateString}.txt`;
        saveAs(blob, filename);
        this.props.onRestartLesson();
    };

    render() {
        return (
            <div>
                <div style={{ border: "1px solid #3ed2b8", borderRadius: "7px" }}>
                    <div>
                        <h2 tabIndex={0} ref={this.resultsHeaderRef}>{strings.RESULTS_HEADER}</h2>
                    </div>

                    <p tabIndex={0} ><b>{this.totalWords + strings.TOTAL_WORDS}</b></p>
                    <p tabIndex={0} ><b>{this.wordsPerMin + strings.WPM}</b></p>
                    <p tabIndex={0} ><b>{this.props.totalErrors + strings.TOTAL_ERRORS}</b></p>
                    <p tabIndex={0} ><b>{this.lessonAccuracy + strings.LESSON_ACCURACY}</b></p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                    {
                        this.props.isPaused ?
                            <GenericButton title={strings.RESUME_BTN_TXT} label={strings.RESUME_BTN_LABEL} onClick={this.props.onResumeLesson} /> :
                            <GenericButton title={strings.NEXT_BTN_TXT} label={strings.NEXT_BTN_LABEL} onClick={this.props.onNextLesson} disabled={this.props.LessonId !== (lessonsList.length)} />
                    }

                    <GenericButton title={this.middleBtnText} label={this.middleBtnLabel} onClick={this.props.onRestartLesson} />
                    <GenericButton title={strings.LOG_RESULTS_BTN_TXT} label={strings.LOG_RESULTS_BTN_LABEL} onClick={this.showLogModal} />
                </div>
                <LogModal onSubmit={this.onSubmitLog} onCancel={this.onCancelLog} />
            </div>
        );
    };
}


export default LessonResults;
